export const sortOptions = ({ options, value: selectedValue }) => {
  if (selectedValue) {
    const unselectedOptions = options.filter(
      option =>
        !(
          option.value === selectedValue.value &&
          option.label === selectedValue.label
        )
    );

    return [selectedValue, ...unselectedOptions];
  }

  return options;
};

export const shouldCreateNewOption = (input, options) => {
  return !options.some(option => option.value === input);
};
